import allfragments from '../fragments/graph';

export const graphQuery = (metric: any) => {
  const fragments = allfragments[metric].query;
  const queryVariables = allfragments[metric].variable;
  return `query queryData(${queryVariables}) {${fragments}}`;
};

export const queryGetAIMetricValues = `query queryData(${allfragments.readAIMetricValues.variable}) {${allfragments.readAIMetricValues.query}}`;

export const queryGetAOMetricValues = `query queryData(${allfragments.readMetricsValues.variable}) {${allfragments.readMetricsValues.query}}`;

export const queryGetAOLabeledMetricValues = `query queryData(${allfragments.readLabeledMetricsValues.variable}) {${allfragments.readLabeledMetricsValues.query}}`;
